export const viewTitle = "Мониторинг";
export const viewUniqKey = "MonitoringBussinessProccesesView";
